import React from "react";
import "./componentsStyle.scss";
import {
  aboutUsTitleIconHeartLabel,
  aboutUsTitleIconHeartTitleLabel,
  aboutUsTitleIconLocationLabel,
  aboutUsTitleIconLocationTitleLabel,
  aboutUsTitleIconPeopleLabel,
  aboutUsTitleIconPeopleTitleLabel,
  aboutUsTitleIconSecurityLabel,
  aboutUsTitleIconSecurityTitleLabel,
  ourPromiseLabel,
  ourStoryDescriptionLabel,
  ourStoryLabel,
  promiseDescriptionLabel,
  whyTravelWithUsLabel,
} from "../constants/translations";
import { SelfGuidedTour, WineTaste } from "../assets/photos";
import { LocSvg, PeopleSvg, SecuritySvg } from "../assets/svg";
import { HeartSvg } from "../assets/svg/HeartSvg";

export const OurStory = ({ languageId }) => {
  return (
    <section className="ourStoryContainer">
      <div className="label">{ourStoryLabel[languageId].label}</div>

      <div className="ourStoryContent">
        {/* Left Side */}
        <div className="ourStoryText">
          {ourStoryDescriptionLabel[languageId].label}
        </div>

        {/* Right Side */}
        <div className="ourStoryImageWrapper">
          <img src={SelfGuidedTour} alt="Our Story" className="ourStoryImage" />
        </div>
      </div>

      <div className="containerIcon">
        <div className="label">{whyTravelWithUsLabel[languageId].label}</div>
        <div className="icons">
          <div className="icon">
            <PeopleSvg width={50} height={50} />
            <span className="title">
              {aboutUsTitleIconPeopleTitleLabel[languageId].label}
            </span>
            <span className="description">
              {aboutUsTitleIconPeopleLabel[languageId].label}
            </span>
          </div>
          <div className="icon">
            <LocSvg width={50} height={50} />
            <span className="title">
              {aboutUsTitleIconLocationTitleLabel[languageId].label}
            </span>

            <span className="description">
              {aboutUsTitleIconLocationLabel[languageId].label}
            </span>
          </div>
          <div className="icon">
            <SecuritySvg width={50} height={50} />
            <span className="title">
              {aboutUsTitleIconSecurityTitleLabel[languageId].label}
            </span>
            <span className="description">
              {aboutUsTitleIconSecurityLabel[languageId].label}
            </span>
          </div>
          <div className="icon">
            <HeartSvg width={50} height={50} />
            <span className="title">
              {aboutUsTitleIconHeartTitleLabel[languageId].label}
            </span>
            <span className="description">
              {aboutUsTitleIconHeartLabel[languageId].label}
            </span>
          </div>
        </div>
      </div>

      <div className="promiseContainer">
        {/* Left Side Image */}
        <div className="promiseImageWrapper">
          <img src={WineTaste} alt="Our Promise" className="promiseImage" />
        </div>

        {/* Right Side Card */}
        <div className="promiseCard">
          <h2>{ourPromiseLabel[languageId].label}</h2>
          <p>{promiseDescriptionLabel[languageId].label}</p>
        </div>
      </div>
    </section>
  );
};
